<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatterPage" id="ALL01">
<div class="chapterHead">
<h2 class="chapterTitle1"><span class="bold">A<span class="smallCaps">LL</span> T<span class="smallCaps">HAT</span> G<span class="smallCaps">LITTERS</span>…</span></h2>
</div>
<div class="chapterBody">
<p class="para">The time had come, but I hesitated. I didn’t feel very heroic. I forced an image of Minnie into my mind. Only through Leviticus Lee could I get the gold I needed to buy her back. Then Lee let out a particularly fearsome scream, and I made my move.</p>
<p class="para">But just as I was about to lunge through the opening between the doors, I heard a shout from inside. “Hold it! I’ve got my gun on you!”</p>
<p class="para">That was Fairweather’s voice—what was he doing in there? He was supposed to enter after me, not before.</p>
<p class="para">Curses, yells, confusion—then a shot, fired just inside the door. Fairweather yelled, fired back. The slug came bursting out through the wall not three inches from my head, sending splinters of wood all over me.</p>
<p class="para"><em class="italic">“Enoch, where are you?”</em></p>
<p class="para">Fairweather’s cry was desperate. I moved quickly, wheeling and dodging straight through the gap between the doors—and from the corner of my eye caught the sight of two riders coming around the ridge that Fairweather and I had come across, and riding onto the grounds of the sawmill. Who they were, and why they had come, I didn’t know. And there was no time to see…</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780312943349_ALL01.vue?e0154fbc